if (!stuller)
	var stuller = {};

stuller.slider = function () {
    var pub = {
        resetTimerOnHover: function (containerId, timerIntervalMs, showNumbersForThumbnails, showStopStart, doImmediateChange) {

            if ($("#" + containerId).data("slideShowAttached") == true) {
                return;
            }

            $("#" + containerId).data("slideShowAttached", true);

            if (doImmediateChange && !$.browser.msie) {
                doImmediateChange = false;
            }
            
            if (doImmediateChange) {
                $('#' + containerId + ' .slideshow .slides .slide:not(.active)').hide();
            }

            $(".slideshow").find(".thumbnails").find("li").each(function () {
                $(this).children("img").wrap("<div />");
            });
            
            var $active;
            var $activeThumbnail;
            var itvl = "";

            $active = $('#' + containerId + ' .slideshow .slides div:first-child');
            $active.addClass("active");

            var numOfSlides = $('#' + containerId + ' .slideshow .slides .slide').length;

            if (showNumbersForThumbnails) {

                //var imgHeight = $('#' + containerId + ' .slideshow .slides .slide:first a img').height();

                if (numOfSlides > 1) {
                    var thumbnailString = '<div class="thumbnails numbers"><ul>';

                    for (var i = 1; i <= numOfSlides; i++) {
                        if (i == 1) {
                            thumbnailString += '<li class="active"></li>';
                        } else {
                            thumbnailString += '<li></li>';
                        }
                    }

                    thumbnailString += '</ul></div>';

                    $('#' + containerId + ' .slideshow .slides').after(thumbnailString);
                    $('.thumbnails.numbers').css('top', 198 ); // imgHeight - 36);
                }
            }
            
            if (showStopStart) {
                $('.previews').before('<div id="startStopButton"><span class="primary smallButton StullerButton"><input type="button" value="Stop" /></span></div>');
            }


            var $currentActiveIndex = 0;

            if (numOfSlides > 1) {
                itvl = setInterval(function () { slideSwitch(false); }, timerIntervalMs);
            }


            function slideSwitch(hoverSwitch) {
                if (itvl != "") {
                    if (!hoverSwitch) {
                        $active = $('#' + containerId + ' .slideshow .slides div.active');
                        $activeThumbnail = $('#' + containerId + ' .slideshow .thumbnails li.active');
                        if ($active.length == 0) {
                            $active = $('#' + containerId + ' .slideshow .slides div:last');
                            $activeThumbnail = $('#' + containerId + ' .slideshow .thumbnails li:last');
                        }

                        // use this to pull the images in the order they appear in the markup
                        var $next = $active.next().length ? $active.next() : $('#' + containerId + ' .slideshow .slides div:first');
                        var $nextThumbnail = $activeThumbnail.next().length ? $activeThumbnail.next() : $('#' + containerId + ' .slideshow .thumbnails li:first');
                        // uncomment the 3 lines below to pull the images in random order
                        // var $sibs = $active.siblings();
                        // var rndNum = Math.floor(Math.random() * $sibs.length );
                        // var $next = $( $sibs[ rndNum ] );
                        $active.addClass('last-active');
                        $nextThumbnail.addClass('active');
                        $activeThumbnail.removeClass('active');
                        if (!doImmediateChange) {
                            $next.css({ opacity: 0.0 })
                                .addClass('active')
                                .animate({ opacity: 1.0 }, 1000, function() {
                                    $active.removeClass('active last-active');
                                });
                        } else {
                            $(".slide").hide();
                            $next.addClass('active');
                            $next.show();
                            $active.removeClass('active last-active');
                        }
                    } else {
                        $('#' + containerId + ' .slideshow .active').removeClass('active');
                        $('#' + containerId + ' .slideshow .last-active').removeClass('last-active');
                        $active.addClass('active last-active');
                        $activeThumbnail.addClass('active');
                        clearInterval(itvl);
                    }
                }
            }

            if (showNumbersForThumbnails) {
                $('#' + containerId + " .slideshow .thumbnails li").mouseenter(function() {
                    $currentActiveIndex = $('#' + containerId + " .slideshow .thumbnails li").index(this);
                    $active = $('#' + containerId + " .slideshow .slides > div:eq(" + $currentActiveIndex + ")");
                    $activeThumbnail = $('#' + containerId + " .slideshow .thumbnails li:eq(" + $currentActiveIndex + ")");
                    slideSwitch(true);
                });

                $('#' + containerId + " .slideshow .thumbnails li").mouseleave(function() {
                    itvl = setInterval(function() { slideSwitch(false) }, timerIntervalMs);
                });
            } else {
                $('#' + containerId + " .slideshow .thumbnails li").mousedown(function () {
                    $currentActiveIndex = $('#' + containerId + " .slideshow .thumbnails li").index(this);
                    $active = $('#' + containerId + " .slideshow .slides > div:eq(" + $currentActiveIndex + ")");
                    $activeThumbnail = $('#' + containerId + " .slideshow .thumbnails li:eq(" + $currentActiveIndex + ")");
                    slideSwitch(true);
                });

                $('#' + containerId + " .slideshow .thumbnails li").mouseup(function () {
                    itvl = setInterval(function () { slideSwitch(false) }, timerIntervalMs);
                });
            }

            $('#startStopButton').live('click', function () {
                if ($(this).children('span').children('input').attr('value') == 'Stop') {
                    $(this).children('span').children('input').attr('value', 'Start');
                    clearInterval(itvl);
                    //i hate clearinterval
                    itvl = "";
                } else {
                    $(this).children('span').children('input').attr('value', 'Stop');
                    itvl = setInterval(function () { slideSwitch(false) }, timerIntervalMs);
                }
            });

            // ** MATCHES FOLLOWING HTML STRUCTURE **
            //        <div id="$containerId">
            //            <div class="slideshow" style="height: XXpx;">
            //                <div class="slides">
            //                    <div class="slide active">
            //                        ...
            //                    </div>
            //                    <div class="slide">
            //                       ...
            //                    </div>
            //                </div>
            //                <div class="thumbnails">
            //                    <div class="thumbnailArrow left">&nbsp;</div>
            //                    <ul class="previews">
            //                        <li class="active">
            //                            ...
            //                        </li>
            //                        <li>
            //                            ...
            //                        </li>
            //                    </ul>
            //                    <div class="thumbnailArrow right">&nbsp;</div>
            //                </div>
            //            </div>
            //        </div> 
        },
        stopMovingOnHover: function (containerId) {

            // Does this need to be redone?

        }
    };
    return pub;
} ();
